export default __webpack_public_path__ + "static/media/1.12cb89c5.png";